"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const prop_types_1 = require("prop-types");
const checkbox_1 = __importDefault(require("@kyruus/checkbox"));
const styles_1 = require("./styles");
const Location_utils_1 = require("./Location.utils");
const BookableLocation = ({ id, name, disabled, isSelected, onSelect, street1 = '', street2 = '', suite = '', city = '', state = '', zip = '' }) => (react_1.default.createElement(styles_1.BookableLocationContainer, { disabled: disabled, className: "BookableLocation", "data-testid": "ProviderLocations__Location" },
    react_1.default.createElement(checkbox_1.default, { disabled: disabled, checked: isSelected, name: id, label: name, hasError: false, labelStyles: `
        & > span:last-of-type {
          border: 0;
          clip: rect(0 0 0 0);
          height: auto;
          margin: 0;
          overflow: hidden;
          padding: 0;
          position: absolute;
          white-space: nowrap;
          width: 1px;
        }
        `, onChange: () => !disabled && onSelect(id) }),
    react_1.default.createElement("div", { itemProp: "address", itemScope: true, itemType: "http://schema.org/PostalAddress" },
        react_1.default.createElement(Location_utils_1.Name, null, name),
        react_1.default.createElement("p", null,
            react_1.default.createElement(Location_utils_1.Street, { street1: street1, street2: street2, suite: suite })),
        react_1.default.createElement("p", null,
            react_1.default.createElement(Location_utils_1.City, null,
                city,
                Boolean(state || zip) && ', '),
            react_1.default.createElement(Location_utils_1.State, null,
                state,
                " "),
            react_1.default.createElement(Location_utils_1.Zip, null, zip)))));
BookableLocation.propTypes = {
    id: prop_types_1.string.isRequired,
    name: prop_types_1.string.isRequired,
    isSelected: prop_types_1.bool.isRequired,
    onSelect: prop_types_1.func.isRequired,
    disabled: prop_types_1.bool.isRequired,
    street1: prop_types_1.string,
    street2: prop_types_1.string,
    suite: prop_types_1.string,
    city: prop_types_1.string,
    state: prop_types_1.string,
    zip: prop_types_1.string
};
exports.default = BookableLocation;
//# sourceMappingURL=BookableLocation.js.map